export const photoStatus = {
  Uploading: 'Uploading',
  Error: 'Error',
  Processing: 'Processing',
  Rejected: 'Rejected',
  Empty: 'Empty',
  NeedsReview: 'NeedsReview',
  Reviewed: 'Reviewed',
} as const;

export const photoTagStatus = {
  Reviewed: 'Reviewed',
  NeedsReview: 'NeedsReview',
  Rejected: 'Rejected',
} as const;

// module.exports = {
//   photoStatus
// };

export default { photoStatus, photoTagStatus };
